import React from "react";
import PropTypes from "prop-types";
import "./styles.css";

const CenteredInputContainer = (props) => {
  const { children } = props;
  return <div className="centered-input-container">{children}</div>;
};

CenteredInputContainer.defaultProps = {
  children: null,
};

CenteredInputContainer.propTypes = {
  children: PropTypes.element,
};

export default CenteredInputContainer;
